export const DEFAULT_AUDIO_NORMALIZATION_LEVEL = -24;
export const QUIETEST_AUDIO_NORMALIZATION_LEVEL = -24;
export const LOUDEST_AUDIO_NORMALIZATION_LEVEL = 0;
export const BETA_TOOLTIP_HEADER = 'Beta Features requires a different transcoder version.';
export const BETA_TOOLTIP_TEXT = ['* Required for Audio Normalization *'];
export const ENABLE_BETA_FEATURES_MODAL_DESCRIPTION =
  'Enabling Beta Features will switch the transcoder version.';
export const DISABLE_BETA_FEATURES_MODAL_DESCRIPTION =
  'Disabling Beta Features clears all beta feature opt-ins and switches to the original transcoder.';
export const LUFS_TOOLTIP_HEADER = 'Common Normalization Levels';
export const LUFS_TOOLTIP_TEXT = [
  'Typical value ranges between -24 and -14.',
  'EBU R128 Broadcast Target: -23 LUFS',
  'A85 Broadcast Target: -24 LUFS',
  'Common Podcast Target: -19 LUFS',
  'Common Webcast Target: -17 LUFS',
  'Alternative Webcast Target: -16 LUFS',
  'Apple Music: -16 LUFS',
  'Deezer: -16 to -14 LUFS',
  'Youtube: -15 to -13 LUFS',
  'Spotify: -14 LUFS',
  'Amazon Music: -13 to -9 LUFS',
  'Soundcloud: -13 to -8 LUFS',
  'CD: -9 LUFS',
];
export const AUDIO_NORMALIZATION_SLIDER_MARKINGS = [
  { value: -24, label: '-24' },
  { value: -23 },
  { value: -19 },
  { value: -17 },
  { value: -16 },
  { value: -14 },
  { value: 0, label: '0' },
];
export const EXTENSION_TYPE_MP4 = 'mp4';

export enum EPadderType {
  PADDER_TYPE_JINGLE = '0',
  PADDER_TYPE_BUMPER = '1',
}
